module.exports = __webpack_public_path__ + "media/images/pc/brands/an/main-visual-text-399b321edbd93e1e38ffef4a643869af.svg";